import React, {useEffect, useRef, useState} from 'react';
import ChatHero from '../../../features/Components/Projects/ProjectsChat/ChatHero';
import ChatParticipants from '../../Components/Projects/ProjectsChat/ChatParticipants';
import './ProjectsChat.scss';
import {useDispatch, useSelector} from 'react-redux';
import {
    getProjectChats,
    getProjectChatsListNew,
    getProjectChatsList,
    postProjectChatsListReadAll,
    getProject,
    postProjectChatsListReadGroup,
} from '../../../redux/actions/projects/projectsActions';
import {useTranslation} from 'react-i18next';

import {notifySuccess} from '../../../helpers/notifySnack';
import ContextMenu from '../../Components/ContextMenu';
import {usePusher} from "../../../context/pusherProvider";
import {
    clearSentArr,
    removeFirstMatchMessageFromArr,
    setChatId,
    setTypeChat
} from "../../../redux/actions/chat/chatActions";
import ChatItems from "./ChatItems/ChatItems";
import {useFetchProjectMembers} from "../../../hooks/chat/useFetchProjectMembers";
import useContextMenu from "../../../hooks/chat/useContextMenu";
import useWindowResize from "../../../hooks/chat/useWindowResize";
import useFetchOnReconnect from "../../../hooks/chat/useRecconnect";

const ProjectsChat = () => {
    const [users, setUsers] = useState(false);
    const [selectedBack, setSelectedBack] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [companies, setCompanies] = useState(false);
    const [common, setCommon] = useState(false);
    const [isChatOpen, setIsChatOpen] = useState(true);
    const [showButtons, setShowButtons] = useState(true);
    const [messages, setMessages] = useState([]);
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const messagesEndRef = useRef(null);
    const [isClickBlocked, setIsClickBlocked] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const [page, setPage] = useState(1);
    const {
        projectMembersList,
        projectChats,
        projectMembersListLoading,
        singleProject
    } = useSelector(
        (state) => state.projects
    );
    const {
        menuData,
        isMenuVisible,
        respondMessage,
        handleRightClick,
        handleClickOutside,
        handleCloseMenu,
        clickReply,
        setRespondMessage
    } = useContextMenu();

    useFetchProjectMembers(singleProject.id, projectMembersList, projectMembersListLoading);

    const {
        windowWidth,
        isMobile
    } = useWindowResize(setIsChatOpen, setShowButtons, setSelectedBack, setCompanies, setCommon);

    const {chatId, typeChat,chatMessagesSend} = useSelector((state => state.chat))


    const {profileMe} = useSelector((state) => state.profile);


    const handleReadAll = async () => {
        try {
            if (isMobile && !common) {
                await Promise.all(
                    projectChats.map(chat => {
                        dispatch(postProjectChatsListReadAll(singleProject.id, chat.id))
                    })
                );
                dispatch(getProjectChats(singleProject.id));
                dispatch(getProject(singleProject.id));
                await fetchMessages();
                return notifySuccess(t('all.successfully'));
            }

            const res = await dispatch(postProjectChatsListReadAll(singleProject.id, chatId));
            if (res.payload?.status === 200) {
                dispatch(getProjectChats(singleProject.id));
                dispatch(getProject(singleProject.id));
                await fetchMessages();
                notifySuccess(t('all.successfully'));
            }
        } finally {
        }
    };

    const handleChat = (chatType) => {
        if ((typeChat === chatType && !isMobile) || isClickBlocked) return;
        setIsClickBlocked(true)
        dispatch(setTypeChat(chatType));
        setMessages([]);

        if (windowWidth < 1080) {
            setIsChatOpen(true);
            setShowButtons(false);
            setSelectedBack(true);

            if (chatType === 'internal') {
                setCompanies(true);
                setCommon(false);
            } else {
                setCommon(true);
                setCompanies(false);
            }
        }

        handleCloseMenu();

        setTimeout(() => {
            setIsClickBlocked(false)
        }, 500)
        const selectedChat = projectChats.find((chat) => chat.type === chatType);
        if (selectedChat) {
            dispatch(clearSentArr())
            dispatch(setChatId(selectedChat.id));
        }
    };

    const handleList = () => {
        setCompanies(false);
        setCommon(false);
        setIsChatOpen(false);
        setSelectedBack(false);
        setShowButtons(true);
        setMessages([]);
        handleCloseMenu();
    };

    const handleUsers = () => {
        setUsers(true);
        setAnchorEl(null);
    };

    const handleCloseUsers = () => {
        setUsers(false);
    };

    const handleClickAnchor = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const openState = Boolean(anchorEl);

    const handleClose = () => {
        setAnchorEl(null);
    };

    const hasCommonChat = projectChats.some((chat) => chat.type === 'default');

    const hasCompaniesChat =
        projectChats.some((chat) => chat.type === 'internal') &&
        profileMe?.role !== 'user' &&
        profileMe?.role !== 'spectator';

    const commonChat = projectChats.find((chat) => chat.type === 'default');
    const companiesChat = projectChats.find((chat) => chat.type === 'internal');

    const fetchMessages = async () => {
        try {
            const [olderRes, newRes] = await Promise.all([
                dispatch(getProjectChatsList(singleProject.id, chatId)),
                dispatch(getProjectChatsListNew(singleProject.id, chatId))
            ]);

            if (olderRes.payload || newRes.payload) {
                const olderMessages = olderRes.payload?.data?.data || [];
                const newMessages = newRes.payload?.data?.data || [];

                const allMessages = [...olderMessages, ...newMessages]

                const uniqueMessages = Array.from(
                    new Map(allMessages.map(msg => [msg.id, msg])).values()
                );


                if(allMessages.length === 0) {
                    setHasMore(false);
                }
                setMessages(uniqueMessages);
                messagesEndRef.current.scrollTop = 0;
            }
        } catch (error) {
            console.error("Ошибка загрузки сообщений:", error);
        }
    };

    const fetchOlderMessages = async () => {
        const container = messagesEndRef.current;
        const previousScrollTop = container?.scrollTop ?? 0;

        setHasMore(false);

        const res = await dispatch(
            getProjectChatsList(singleProject.id, chatId, page)
        );

        const olderMessages = res.payload?.data?.data || [];

        if (olderMessages.length === 0) {
            setHasMore(false);
        } else {
            setPage(page + 1)
            setMessages((prev) => [...olderMessages, ...prev]);
            // setTimeout(() => {
                container.scrollTop = previousScrollTop;
                setHasMore(true);
            // }, 0)

        }
    };

    const clickHandler = () => {
        setRespondMessage(menuData.message);
        handleClickOutside();
    };

    const readMessageGroup = async (messages) => {
        const res = await dispatch(postProjectChatsListReadGroup(singleProject.id, chatId, messages));
    }

    const scrollDown = () => {
        if (messagesEndRef.current) {
            messagesEndRef.current.scrollTop = messagesEndRef.current.scrollHeight;
        }
    }
    const {pusherInstance} = usePusher();

    useEffect(() => {
        if (pusherInstance && chatId) {
            const handleChatMessageCreated = (data) => {
                if (data.chatId === chatId) {
                    const isOwnMessage = String(profileMe?.id) === String(data.sender?.id);
                    if (isOwnMessage) {
                        dispatch(removeFirstMatchMessageFromArr('message' || ''))
                        setMessages((prevMessages) => {
                            if (prevMessages.some(message => message.id === data.id)) {
                                return [...prevMessages];
                            } else {
                                return [...prevMessages, data];
                            }
                        });
                        scrollDown()
                    }
                    else {
                        setMessages((prevMessages) => [...prevMessages, data]);
                        readMessageGroup([data.id])
                    }
                }
            };
            pusherInstance.bind("chat.message.created", handleChatMessageCreated);
            return () => {
                dispatch(clearSentArr())
                pusherInstance.unbind("chat.message.created", handleChatMessageCreated);
            }
        }
    }, [pusherInstance, chatId, profileMe?.id])

    useEffect(() => {
        dispatch(getProjectChats(singleProject.id));
    }, [singleProject.id]);

    useEffect(() => {
        if (projectChats.length > 0) {
            const commonChat = projectChats.find((chat) => chat.type === 'default');
            const initialChatId = commonChat ? commonChat.id : null;

            if (!chatId) {
                dispatch(setChatId(initialChatId))
            }
        }
    }, [projectChats, chatId]);

    useEffect(() => {
        if (chatId && isChatOpen) {
            fetchMessages().then(() => {
                dispatch(postProjectChatsListReadAll(singleProject.id, chatId))
                setPage(page + 1)
            })

        }
    }, [dispatch, singleProject.id, chatId, isChatOpen]);

    useFetchOnReconnect(fetchMessages)

    return (
        <div className='projects-chat'>
            <div className='projects-name'>{singleProject.address}</div>
            <div className='projects-chat__wrapper'>
                <div className='projects-chat__content'>
                    <ChatHero
                        commonName={t('ProjectsChat.name')}
                        companiesName={t('ProjectsChat.companies')}
                        title={t('ProjectsChat.project_chat')}
                        common={common}
                        companies={companies}
                        selectedBack={selectedBack}
                        handleList={handleList}
                        handleUsers={handleUsers}
                        handleClickAnchor={handleClickAnchor}
                        handleReadAll={handleReadAll}
                        openState={openState}
                        handleClose={handleClose}
                        anchorEl={anchorEl}
                        isMobile={isMobile}
                    />

                    {showButtons && (
                        <div className='projects-chat__tabs'>
                            {(hasCommonChat || hasCompaniesChat) && (
                                <div className='projects-chat__btn'>
                                    {hasCommonChat && (
                                        <div
                                            className={`btn btn-common ${typeChat === 'default' ? 'active' : ''}`}
                                            onClick={() => handleChat('default')}
                                        >
                                            <div className='info'>
                                                {t('ProjectsChat.name')}
                                                <span>{commonChat.messageCount}</span>
                                            </div>
                                            {commonChat.messageUnreadCount !== 0 && (
                                                <div className='notification'>+{commonChat.messageUnreadCount}</div>
                                            )}
                                        </div>
                                    )}
                                    {hasCompaniesChat && (
                                        <div
                                            className={`btn btn-companies ${typeChat === 'internal' ? 'active' : ''}`}
                                            onClick={() => handleChat('internal')}
                                        >
                                            <div className='info'>
                                                {t('ProjectsChat.companies')}
                                                <span>{companiesChat.messageCount}</span>
                                            </div>
                                            {companiesChat.messageUnreadCount !== 0 && (
                                                <div className='notification'>+{companiesChat.messageUnreadCount}</div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                    <ChatItems
                        hasMore={hasMore}
                        fetchMessages={fetchMessages}
                        chatId={chatId} handleCloseMenu={handleCloseMenu}
                        handleRightClick={handleRightClick}
                        clickReply={clickReply}
                        handleClickOutside={handleClickOutside} hasCommonChat={hasCommonChat}
                        hasCompaniesChat={hasCompaniesChat} isChatOpen={isChatOpen} menuData={menuData}
                        messages={messages} messagesEndRef={messagesEndRef}
                        profileMe={profileMe} typeChat={typeChat} singleProject={singleProject}
                        respondMessage={respondMessage}
                        fetchOlderMessages={fetchOlderMessages}
                        setPage={setPage}
                    />
                </div>
                {users && (
                    <ChatParticipants
                        descriptions={t('ProjectsChat.participantss')}
                        title={t('ProjectsChat.participants')}
                        handleCloseUsers={handleCloseUsers}
                        activeChatType={typeChat}
                        projectMembersList={projectMembersList}
                    />
                )}
            </div>
            <ContextMenu menuData={menuData} isVisible={isMenuVisible} clickHandler={clickHandler}/>
        </div>
    );
};

export default ProjectsChat;
